import { useSuspenseQuery, UseSuspenseQueryOptions } from "@tanstack/react-query";
import { Delivery } from "@/types";
import { api, ErrorResponse } from "@/utils/api";
import { camelize } from "@/utils/api-helpers";

export const useDelivery = (
  projectId: string,
  notificationId: string,
  deliveryId: string,
  options: Omit<UseSuspenseQueryOptions<unknown, ErrorResponse, Delivery>, "queryKey"> = {}
) => {
  return useSuspenseQuery<unknown, ErrorResponse, Delivery>({
    queryKey: ["projects", projectId, "notifications", notificationId, "deliveries", deliveryId],
    queryFn: async (): Promise<Delivery> => {
      const response = await api.get<Delivery>(
        `/projects/${projectId}/notifications/${notificationId}/deliveries/${deliveryId}`
      );
      return camelize(response.data);
    },
    ...options
  });
};
